window.GIFTBOX_CUSTOM_CART_ITEMS_SELECTORS = [".cart__line-item"]

window.GIFTBOX_CUSTOM_CART_REMOVE_LINK_SELECTORS= ['.cart__line-item--title a']

window.GIFTBOX_CUSTOM_CART_REMOVE_INPUTS_SELECTORS = [".NumberStepper__button"]

const styleGB = document.createElement("style")
styleGB.id = "giftbox_style"
styleGB.textContent = `#giftbox-root {opacity: 0!important}`
document.head.appendChild(styleGB)


const gbint2 = setInterval(()=>{
    const addedOffers = JSON.parse(window.localStorage.getItem("giftbox-added-offers") || "[]")
   const style = document.querySelector("#giftbox_style")
    if (addedOffers.length > 0 && style) {
        
        style.remove()
        clearInterval(gbint2)
    }
}
, 750)



// Hiding gifts on collection pages
setInterval(()=>{
    const freeGiftsGrid = document.querySelectorAll(".product-grid-item--link[href*='oferta']")

    freeGiftsGrid.forEach(g=>{
        const wrapper = g.closest(".grid__item")
        wrapper.style.display = "none"
    }
    )

}
, 200)

// Cart update
window.GIFTBOX_CUSTOM_UPDATE_CART = () => {
if(window.getCart) {
   window.getCart()
}
}